import { useState } from "react";
import { Transition } from "@headlessui/react";
import * as Animate from "react-reveal";

const faqs = [
  {
    question: "Can Utiva customise a programme for our organisation?",
    answer:
      "Yes. The learning pathway can be shaped around your capability gaps, employee levels, preferred schedule, business cases and measurement needs.",
  },
  {
    question: "How are programmes delivered?",
    answer:
      "Programmes can combine live online classes, digital content, practical projects, coaching and a dedicated learning environment for your organisation.",
  },
  {
    question: "Which teams can participate?",
    answer:
      "Utiva can support graduate cohorts, functional teams, managers, technical professionals and cross-functional groups at different experience levels.",
  },
  {
    question: "How long does a workforce programme take?",
    answer:
      "Programmes range from focused six-to-eight-week training to broader academies. Final duration depends on scope and outcomes.",
  },
];

const FaqItem = ({ question, answer, isOpen, onToggle }) => (
  <div className="border-b border-hire-line">
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-4 py-6 text-left focus:outline-none"
    >
      <span className="font-poppins font-bold text-base md:text-lg text-primary">
        {question}
      </span>
      <span className="flex-none text-primary text-xl" aria-hidden="true">
        {isOpen ? "×" : "+"}
      </span>
    </button>
    <Transition
      show={isOpen}
      enter="transition ease-out duration-150"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <p className="pb-6 text-gray font-poppins text-sm leading-relaxed m-0 max-w-xl">
        {answer}
      </p>
    </Transition>
  </div>
);

const BusinessFaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Frequently asked questions
              </p>
              <h2 className="text-3xl md:text-4xl leading-tight font-poppins font-black mb-6 tracking-[-0.03em] text-primary">
                What business leaders usually ask first.
              </h2>
              <p className="font-poppins text-gray text-base">
                Need a more specific answer?{" "}
                <a
                  href="mailto:business@utiva.io"
                  className="text-primary font-extrabold hover:text-secondary transition-colors"
                >
                  Talk to the Utiva Business team →
                </a>
              </p>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div className="border-t border-hire-line">
              {faqs.map((faq, index) => (
                <FaqItem
                  key={faq.question}
                  question={faq.question}
                  answer={faq.answer}
                  isOpen={openIndex === index}
                  onToggle={() =>
                    setOpenIndex((current) => (current === index ? -1 : index))
                  }
                />
              ))}
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default BusinessFaqSection;
